<template>
  <div class="my-2.5 border-t border-primary-purple-100"></div>
</template>
